import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Button from "../../Button";
import { DialogActions, DialogContentText, Grid } from "@material-ui/core";

const UnlinkWindow = ({ setOpenUnlinkWindow, vendor, setVendor, memberID, doUnlinkMemberDevices }) => {

    return (
        <Dialog
            open={true}
            contentlabel="Unlink Window"
            ariaHideApp={false}
            fullWidth={true}
            maxHeight="80%"
            maxWidth={"xs"}
        >
            <DialogTitle>
                <Typography color="secondary" variant="h6">
                    Unlink Devices
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Grid container style={{justifyContent: 'center', textAlign: 'center'}}>
                        <Grid item>
                            Are you sure you wanted to unlink all {vendor} devices with this member? This action cannot be reversed.
                        </Grid>
                    </Grid>
                </DialogContentText>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setVendor("")
                            setOpenUnlinkWindow(false)
                            doUnlinkMemberDevices(memberID, vendor)
                        }}
                        variant="contained"
                        color="secondary"
                    >
                        Continue
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={async () => {
                            await setVendor("")
                            await setOpenUnlinkWindow(false);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default UnlinkWindow;
